module.exports = __webpack_public_path__ + "assets/lessons/pl/lesson7/pages/lesson_7_5.pdf";